import VT from '@/store/types';

export default {
  [VT.ROLES_LIST]: (state, { data, status }) => {
    state.rolesList = { data, status };
  },
  [VT.ROLE_CREATE_DATA]: (state, { data, status }) => {
    state.roleCreateData = { data, status };
  },
  [VT.ROLE_UPDATE_DATA]: (state, { data, status }) => {
    state.roleUpdateData = { data, status };
  },
  [VT.ROLE_CREATE]: (state, { data, status }) => {
    state.roleCreate = { data, status };
  },
  [VT.ROLE_UPDATE]: (state, { data, status }) => {
    state.roleUpdate = { data, status };
  }
};
